<template>
  <div class="box">
    <div class="formClass">
      <el-form
        ref="queryForm"
        :label-position="$i18n.locale!=='zh'?'top':'right'"
        :label-width="$i18n.locale==='zh'?'120px':''"
        :model="param"
        :rules="rules"
        size="small"
        class="queryFormClass"
      >
        <el-row :gutter="20">
          <el-col v-if="operationType === 2" :span="24">
            <!--费用编码-->
            <el-form-item :label="$t('basicData.FeeCode')" prop="code">
              <span>{{ param.code }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!--费用名称-->
            <el-form-item :label="$t('basicData.ExpenseName')" prop="name">
              <el-input v-model="param.name" :placeholder="$t('basicData.PleaseEnter')" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!--费用名称(PU)-->
            <el-form-item :label="$t('basicData.ExpenseName') + '(PU)'" prop="namePu">
              <el-input v-model="param.namePu" :placeholder="$t('basicData.PleaseEnter')" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!--业务类型-->
            <el-form-item :label="$t('collectionCenter.businessT')" prop="businessType">
              <el-select v-model="param.businessType" :placeholder="$t('GlobalSetObj.pleaseChoose')" multiple>
                <el-option
                  v-for="item in BUSINESS_TYPE"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('basicData.Attribute')">
              <el-select v-model="param.property" clearable :placeholder="$t('GlobalSetObj.pleaseChoose')">
                <el-option
                  v-for="item in feeAttributeList"
                  :key="item.dictValue"
                  :value="item.dictValue"
                  :label="item.dictValue"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!--状态-->
            <el-form-item :label="$t('basicData.status')" prop="state">
              <el-radio-group v-model="param.state" size="small">
                <!--禁用-->
                <el-radio-button :label="false">{{ $t('basicData.disable') }}</el-radio-button>
                <!--启用-->
                <el-radio-button :label="true">{{ $t('basicData.enable') }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!--备注-->
            <el-form-item :label="$t('basicData.remark')" prop="remark">
              <el-input
                v-model="param.remark" :placeholder="$t('basicData.PleaseEnter')" :rows="4"
                type="textarea"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!--特殊规则-->
            <el-form-item :label="$t('basicData.SpecialRules')" prop="specialRules">
              <el-select v-model="param.specialRules" :placeholder="$t('GlobalSetObj.pleaseChoose')" clearable>
                <el-option
                  v-for="item in SpecialRules"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div
      v-permit:remove="'btn:finance:basicData:feesType:add'"
      style="text-align: right;padding: 10px;border-top: 1px solid #ccc;"
    >
      <!--取消-->
      <el-button size="small" @click="saveFormData(2)">{{ $t('basicData.Cancel') }}</el-button>
      <!--保存-->
      <el-button size="small" type="primary" @click="saveFormData(1)">{{ $t('basicData.Save') }}</el-button>
    </div>
  </div>
</template>

<script>
import { addFeeType, editFeeType } from '@/api/finance/partition';
import { cloneDeep } from 'lodash-es';
import { SpecialRules } from '@/views/finance/basicData/feeType/consts';
import { BUSINESS_TYPE } from '@/views/finance/enums';

export default {
  name: 'CheckDetail',
  props: {
    // 详情数据
    detailData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 1 新增 2 修改
    operationType: {
      type: Number,
      default: 1
    },
    // 费用属性
    feeAttributeList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      SpecialRules,
      BUSINESS_TYPE,
      rules: {
        name: [
          { required: true, message: this.$t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
        ],
        namePu: [
          { required: true, message: this.$t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
        ],
        businessType: [
          { required: true, message: this.$t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
        ]
      },
      param: {}
    };
  },
  created() {
    this.param = cloneDeep(this.detailData);
    this.setData();
  },
  methods: {
    setData() {
      // 业务类型枚举
      const BUSINESS_TYPE_MAP = {
        0: [0], // 快递
        1: [1], // 揽收
        2: [2], // 派送
        3: [0, 1], // 快递+揽收
        4: [0, 2], // 快递+派送
        5: [1, 2], // 揽收+派送
        6: [0, 1, 2], // 快递+揽收+派送
        8: [8], // 整车
        9: [0, 8], // 快递+整车
        10: [1, 8], // 揽收+整车
        11: [2, 8], // 派送+整车
        12: [0, 1, 8], // 快递+揽收+整车
        13: [0, 2, 8], // 快递+派送+整车
        14: [1, 2, 8], // 揽收+派送+整车
        15: [0, 1, 2, 8] // 快递+揽收+派送+整车
      };

      if (this.param && this.param.businessType !== undefined) {
        const mappedValue = BUSINESS_TYPE_MAP[this.param.businessType];
        if (mappedValue) {
          this.param.businessType = mappedValue;
        }
      }
    },
    saveFormData(type) {
      if (type === 1) {
        this.$refs['queryForm'].validate(valid => {
          if (!valid) return;
          const params = cloneDeep(this.param);
          const businessTypeMap = {
            '0': '0',
            '1': '1',
            '2': '2',
            '0,1': '3',
            '0,2': '4',
            '1,2': '5',
            '0,1,2': '6',
            '8': '8',
            '0,8': '9',
            '1,8': '10',
            '2,8': '11',
            '0,1,8': '12',
            '0,2,8': '13',
            '1,2,8': '14',
            '0,1,2,8': '15'
          };

          const key = params.businessType.join(',');
          if (Object.prototype.hasOwnProperty.call(businessTypeMap, key)) {
            params.businessType = businessTypeMap[key];
          }

          const API = this.operationType === 1 ? addFeeType : editFeeType;
          API(params).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
              this.$emit('saveChange', type);
            }
          });
        });
      } else {
        this.$emit('saveChange', type);
      }
    }
  }
};
</script>

<style scoped>
.formClass {
  height: calc(100vh - 138px);
  overflow-y: auto;
  padding: 20px;
}
</style>
